import { v4 as uuid } from "uuid";

export const categoryData=[
    {
         id:"222b9b66-4a8f-4988-958a-3b7f9b8f983a",
         image:"https://res.cloudinary.com/doohtm4bs/image/upload/v1652512639/Quiz%20App/odi_jrsqzk.png",
         category:"ODI cricket"
    },
    {
        id:"7f2872df-9b07-4953-bcfe-aa45bd9d7751",
        image:"https://res.cloudinary.com/doohtm4bs/image/upload/v1652512636/Quiz%20App/test_jfruru.jpg",
        category:"Test cricket"
   }
]